import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-sme-groups-list',
  templateUrl: './sme-groups-list.component.html',
  styleUrls: ['./sme-groups-list.component.scss'],
})
export class SmeGroupsListComponent implements OnInit {
  smes: any[];

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.smes = [
      {
        id: 1,
        title: 'SME Group 1',
      },
      {
        id: 2,
        title: 'SME Group 2',
      },
      {
        id: 3,
        title: 'SME Group 3',
      },
      {
        id: 4,
        title: 'SME Group 4',
      },
      {
        id: 5,
        title: 'SME Group 5',
      },
      {
        id: 6,
        title: 'SME Group 6',
      },
      {
        id: 7,
        title: 'SME Group 7',
      },
      {
        id: 8,
        title: 'SME Group 8',
      },
    ];
  }

  goToSMEDetails(id: number): void {
    this.router.navigate(['/sme-group-details', id]);
  }
}
